<!-- 状态面板 -->
<template>
    <div v-if="componentsData.type == 28">
        <div
            class="status-panel bg-div"
            :style="{
                ...(componentsData.content.bg_color && {
                    backgroundColor: componentsData.content.bg_color,
                }),
                ...(componentsData.content.bg_img &&
                    componentsData.content.bg_img.picview &&
                    componentsData.content.bg_value && {
                        backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                    }),
                padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
            }"
        >
            <div
                :class="
                    componentsData.content.style_value == '2'
                        ? 'status-grid status-grid-2'
                        : 'status-grid status-grid-1'
                "
            >
                <div
                    class="status-card"
                    v-for="(item, index) in componentsData.content.statusList"
                    :key="index"
                >
                    <div class="status-title">{{ item.title }}</div>
                    <div
                        class="status-value"
                        :style="{ color: statusColor(item) }"
                    >
                        {{ item.current_status }}
                    </div>
                    <div class="status-time">8月28日 14:23 更新</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    methods: {
        statusColor(item) {
            const status = item.current_status;
            const options = item.statusOptions || [];
            const opt = options.find((o) => o.name === status);
            if (opt && opt.color) return opt.color;
            if (status === "正常") return "#52C41A";
            if (status === "异常") return "#F5222D";
            return "#FF761D";
        },
    },
};
</script>

<style scoped>
.status-panel {
    overflow: hidden;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.status-grid {
    display: flex;
    flex-wrap: wrap;
}
.status-grid-1 .status-card {
    width: 100%;
}
.status-grid-1 .status-card + .status-card {
    border-top: 1px solid #eee;
}
.status-grid-2 .status-card {
    width: 50%;
    box-sizing: border-box;
}
.status-grid-2 .status-card:nth-child(odd) {
    border-right: 1px solid #eee;
}
.status-grid-2 .status-card:nth-child(n + 3) {
    border-top: 1px solid #eee;
}
.status-card {
    padding: 16px 14px;
    box-sizing: border-box;
}
.status-title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    line-height: 1.4;
}
.status-value {
    margin-top: 10px;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
}
.status-time {
    margin-top: 10px;
    font-size: 12px;
    color: #999;
    line-height: 1.4;
}
</style>
